// ** Initial State
const initialState = {
  dropdown: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedWorkLocation: null
}

const workLocations = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_WORK_LOCATIONS_DROPDOWN':
      return { ...state, dropdown: action.data }
    case 'GET_ALL_WORK_LOCATIONS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_WORK_LOCATIONS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_WORK_LOCATION':
      return { ...state, selectedWorkLocation: action.selectedWorkLocation }
    case 'ADD_WORK_LOCATION':
      return { ...state }
    case 'DELETE_WORK_LOCATION':
      return { ...state }
    default:
      return { ...state }
  }
}
export default workLocations
